const handleInitCartUSP = () => {
  new Swiper('.js-cart-usp-slider', {
    autoplay: {
      delay: 5000,
    },
    loop: true,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
  });
};

window.addEventListener('DOMContentLoaded', handleInitCartUSP);
